module.exports = __webpack_public_path__ + "img/ANTENNA RADIO 2 PURPLE.397fba0.svg";